import React, { forwardRef, useId, useRef, useState } from 'react'
import { InputGroup, AutoComplete } from 'rsuite'
import FormFieldErrorIcon from './FormFieldErrorIcon'
import IconIndicator from '../user-feedback/IconIndicator'
import { parseArbitraryStringToHtmlElementId } from '../../common/utils'

export const AutocompleteWithErrorStatus = React.memo(
    forwardRef(
        (
            {
                showError,
                errorMessage,
                hideErrorIcon,
                data,
                onChange,
                onSelect,
                isLoading = false,
                ...props
            },
            ref
        ) => {
            return (
                <InputGroup role="group" {...props} ref={ref}>
                    <AutoComplete
                        aria-activedescendant={undefined}
                        aria-label={props?.name}
                        data={data}
                        onChange={onChange}
                        onSelect={(selected) => {
                            const match = data.find(add => add === selected);
                            onSelect({ address: selected, components: match?.components });
                        }}
                        value={props.value}
                    />
                    {!hideErrorIcon && showError && (
                        <InputGroup.Addon tabIndex={-1}>
                            <FormFieldErrorIcon errorMessage={errorMessage} />
                        </InputGroup.Addon>
                    )}
                    {isLoading && (
                        <InputGroup.Addon 
                            tabIndex={-1}
                            style={{backgroundColor: "transparent"}}
                        >
                            <IconIndicator 
                                size={16}
                                color='#D1D1D1'
                            />
                        </InputGroup.Addon>
                    )}
                </InputGroup>
            )
        }
    )
)
